import { ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { Link, useParams } from "react-router-dom";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { MdmTable } from "src/components/MdmTable";
import { PageLayout } from "src/components/PageLayout";
import { PageSubheader } from "src/components/PageSubheader";
import { RtColumnsSettingsButton } from "src/components/ReactiveTable/components/RtColumnsSettings";
import { ToolBox2 } from "src/components/ToolBox2";
import { BookIcon } from "src/icons";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import {
  WorkflowCardsData,
  workflowCardsPageStore as pageStore,
} from "./workflowCardsPageStore";

export const WorkflowCardsPage: React.FC = observer(() => {
  const { id: workflowId = "" } = useParams();

  React.useEffect(() => {
    pageStore.init(workflowId);
    return () => pageStore.dispose();
  }, [workflowId]);

  return (
    <PageLayout title={pageStore.title}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: WorkflowCardsData }> = observer(({ data }) => {
  const {
    table,
    catalog: { id: catalogId },
  } = data;
  const tools = (
    <>
      <RtColumnsSettingsButton store={table} />
      <Button
        icon={<ReloadOutlined />}
        onClick={() => table.reload().catch(onError)}
      />
    </>
  );
  return (
    <>
      <PageSubheader title={pageStore.workflowName}>
        <Link to={makeUrl(PageUrl.records, { id: catalogId })}>
          <Button type="link" icon={<BookIcon />}>
            К исходным записям
          </Button>
        </Link>
      </PageSubheader>

      <ToolBox2 paddingMode="page" extraTools={tools}>
        <MdmTable
          store={table}
          columns={pageStore.columns}
          resizableColumns
          rowClick={{
            type: "link",
            builder: (row) => makeUrl(PageUrl.editRecordWf, { id: row.id }),
          }}
        />
      </ToolBox2>
    </>
  );
});
